<template>
    <v-container
        fluid>
        <v-dialog
            v-model="dialog"
            fullscreen
            transition="dialog-bottom-transition">

            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    icon
                    @click="init">
                    <v-icon>mdi-account-multiple</v-icon>
                </v-btn>
            </template>
            <v-card
                tile>
                <v-toolbar
                    dense
                    fixed
                    dark
                    color="primary"
                    style="width: 100%; position: fixed; z-index: 100">
                    <v-btn
                        icon
                        dark
                        @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('BuildingContactList.contactList') }} {{ building.name || buildingUuid }}</v-toolbar-title>
                </v-toolbar>
                <v-container>
                    <v-row dense style="margin-top: 64px;">
                        <v-flex xs12>
                            <v-data-table
                                :headers="headers"
                                :items="usedContacts"
                                class="elevation-1"
                                :search="search"
                                :loading="loading"
                                multi-sort
                                hide-default-footer
                                :items-per-page="buildingContacts.length + 1"
                            >
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-text-field
                                            v-model="search"
                                            append-icon="mdi-magnify"
                                            :label="searchFilter"
                                            single-line
                                            clearable
                                            hide-details
                                        />
                                        <v-spacer/>
                                        <v-dialog
                                            scrollable
                                            v-model="contactListDialog"
                                            max-width="750px">
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    text
                                                    class="mb-2 text--secondary"
                                                    v-on="on">
                                                    {{ $t('BuildingContactList.addContact') }}
                                                </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline"></span>
                                                    <v-text-field
                                                        class="text--secondary"
                                                        :label="searchUser"
                                                        v-model="userSearch"
                                                        append-icon="mdi-clear"
                                                    />
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-container v-scroll>
                                                        <v-list>
                                                            <v-list-item
                                                                two-line
                                                                v-for="item in filteredContacts"
                                                                :key="item.uuid"
                                                            >
                                                                <v-list-item-content>
                                                                    <v-list-item-title>{{ item.name }}
                                                                    </v-list-item-title>
                                                                    <v-list-item-subtitle>
                                                                        {{ item.position }} {{ item.surName }}
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>
                                                                <v-list-item-action>
                                                                    <v-btn
                                                                        @click="addContactToBuilding(item)"
                                                                        icon>
                                                                        <v-icon>mdi-account-plus</v-icon>
                                                                    </v-btn>
                                                                </v-list-item-action>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-container>
                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer/>
                                                    <v-btn
                                                        color="primary"
                                                        text
                                                        @click="contactListDialog = false">
                                                        {{ $t('BuildingContactList.close') }}
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.mobileNumber="{ item }">
                                    <span v-if="item.mobileNumber !== '00'">{{ item.mobileNumber }}</span>
                                </template>
                                <template v-slot:item.notificationType="{ item }">
                                    <v-select
                                        dense
                                        style="width: 120px"
                                        v-model="item.notificationType"
                                        :items="getNotificationItems(item)"
                                        hide-selected
                                        item-text="name"
                                        item-value="value"
                                        hide-details
                                        @change="updateNotificationType(item)"
                                    ></v-select>
                                </template>
                                <template v-slot:item.contactUuid="{ item }">
                                    <v-checkbox
                                        style="width: 120px"
                                        dense
                                        v-model="item.sendUsageData"
                                        @change="updateSendUsageData(item)"
                                    ></v-checkbox>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                                class="mr-3"
                                                @click="deleteContact(item.uuid)"
                                            >
                                                mdi-account-remove
                                            </v-icon>
                                        </template>
                                        <span>Kontakt aus Liste entfernen</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import axios from 'axios'

export default {
    data() {
        return {
            search: '',
            userSearch: '',
            buildingUuid: {},
            building: {},
            dialog: false,
            contactListDialog: false,
            toggling: false,
            loading: true,
            buildingContacts: [],
            headers: [
                {text: this.$t('BuildingContactList.name'), value: 'name'},
                {text: this.$t('BuildingContactList.email'), value: 'email'},
                {text: this.$t('BuildingContactList.mobile'), value: 'mobileNumber'},
                {text: this.$t('BuildingContactList.notificationType'), value: 'notificationType'},
                {text: this.$t('BuildingContactList.mailingStats'), value: 'contactUuid'},
                {text: '', value: 'action', sortable: false, align: 'end'}
            ]
        }
    },
    computed: {
        filteredContacts() {
            return this.allContacts.filter(item => {
                if (typeof item.name != 'undefined'
                    && item.name.toLowerCase().includes(this.userSearch.toLowerCase()) ||
                    typeof item.position != 'undefined'
                    && item.position.toLowerCase().includes(this.userSearch.toLowerCase()) ||
                    typeof item.surName != 'undefined'
                    && item.surName.toLowerCase().includes(this.userSearch.toLowerCase())
                ) {
                    for (let i = 0; i < this.buildingContacts.length; i++) {
                        if (this.buildingContacts[i].contactUuid === item.uuid) {
                            return false
                        }
                    }
                    return true
                } else {
                    return false
                }
            })
        },
        allContacts() {
            return this.$store.getters.getContacts
        },
        usedContacts() {
            return this.allContacts.filter(item => {
                for (let i = 0; i < this.buildingContacts.length; i++) {
                    if (this.buildingContacts[i].contactUuid === item.uuid) {
                        item.notificationType = this.buildingContacts[i].notificationType;
                        item.sendUsageData = this.buildingContacts[i].sendUsageData;
                        return true
                    }
                }
                return false
            })
        },
        searchFilter: function () {
            return this.$t('BuildingContactList.searchFilter');
        },
        searchUser: function () {
            return this.$t('BuildingContactList.searchUser');
        }
    },
    methods: {
        init(buildingUuid) {
            this.buildingUuid = buildingUuid;
            this.dialog = true;
            this.loading = true;

            axios.get(`/address-contact/api/building/${buildingUuid}/`)
                .then(response => {
                    this.building = response.data;
                })
            axios.get(`/notification/api/notification/?building=${buildingUuid}`)
                .then(response => {
                    this.buildingContacts = response.data;
                    this.loading = false
                })
        },
        getNotificationItems(contact) {
            if (contact.mobileNumber === null || contact.mobileNumber === '00')
                return [
                    {name: 'Mail', value: 'MAIL'},
                    {name: '-', value: 'NONE'}
                ];
            return [
                {name: 'Mail', value: 'MAIL'},
                {name: 'SMS', value: 'SMS'},
                {name: '-', value: 'NONE'}
            ];
        },
        addContactToBuilding(contact) {
            let c = {
                buildingUuid: this.buildingUuid,
                contactUuid: contact.uuid,
                notificationType: (typeof contact.email != "undefined" && contact.email !== null) ? 'MAIL' : 'SMS'
            };
            axios.post('/notification/api/notification/', c)
                .then(response => {
                    this.buildingContacts.push(response.data)
                })
        },
        deleteContact(uuid) {
            let item = this.contactUuidToItem(uuid);
            axios.delete(`/notification/api/notification/${item.uuid}/`)
                .then(() => {
                    this.buildingContacts.splice(this.buildingContacts.findIndex((i) => {
                        return i.uuid === item.uuid
                    }), 1)
                })
        },
        close() {
            this.dialog = false;
        },
        updateNotificationType(contact) {
            let item = this.contactUuidToItem(contact.uuid);
            item.notificationType = contact.notificationType;
            axios.put(`/notification/api/notification/${item.uuid}/`, item)
                .then(response => {
                    this.buildingContacts.splice(this.buildingContacts.findIndex((i) => {
                        return i.uuid === item.uuid
                    }), 1, response.data);
                    this.toggling = false
                })
        },
        updateSendUsageData(contact) {
            let item = this.contactUuidToItem(contact.uuid);
            item.sendUsageData = contact.sendUsageData;
            axios.put(`/notification/api/notification/${item.uuid}/`, item)
                .then(response => {
                    this.buildingContacts.splice(this.buildingContacts.findIndex((i) => {
                        return i.uuid === item.uuid
                    }), 1, response.data);
                    this.toggling = false
                });
        },
        contactUuidToItem(uuid) {
            return this.buildingContacts.find((i) => {
                return i.contactUuid === uuid
            });
        }
    }
}
</script>
